<template>
  <label class="measurement-ruler-toggle">
    <input
      class="measurement-ruler-toggle__input"
      type="checkbox"
      role="switch"
      :checked="visible"
      aria-label="Show ruler"
      @change="handleChange"
    >
    <span
      class="measurement-ruler-toggle__track"
      aria-hidden="true"
    >
      <span class="measurement-ruler-toggle__thumb" />
    </span>
    <span class="measurement-ruler-toggle__label">Show Ruler</span>
  </label>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useMeasurementRulerStore } from "@/store/modules/measurementRuler";

const props = defineProps<{
  taskId: string;
}>();

const rulerStore = useMeasurementRulerStore();
const visible = computed(() => rulerStore.isVisible(props.taskId));

function handleChange(event: Event) {
  rulerStore.setVisible(props.taskId, (event.target as HTMLInputElement).checked);
}
</script>

<style scoped>
.measurement-ruler-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: #212121;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  white-space: nowrap;
}

.measurement-ruler-toggle__input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
}

.measurement-ruler-toggle__track {
  position: relative;
  width: 32px;
  height: 18px;
  flex: 0 0 32px;
  border: 1px solid #6b7280;
  border-radius: 9px;
  background: #ffffff;
  transition: background-color 120ms ease, border-color 120ms ease;
}

.measurement-ruler-toggle__thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #4b5563;
  transition: transform 120ms ease, background-color 120ms ease;
}

.measurement-ruler-toggle__input:checked + .measurement-ruler-toggle__track {
  border-color: #1565c0;
  background: #1565c0;
}

.measurement-ruler-toggle__input:checked + .measurement-ruler-toggle__track .measurement-ruler-toggle__thumb {
  background: #ffffff;
  transform: translateX(14px);
}

.measurement-ruler-toggle__input:focus-visible + .measurement-ruler-toggle__track {
  outline: 2px solid #1565c0;
  outline-offset: 2px;
}
</style>
